/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$:
    DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponseData;

  constructor(
    err:
      DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse";
  }
}

/** @internal */
export const DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse$inboundSchema:
  z.ZodType<
    DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse(
        v,
      );
    });

/** @internal */
export type DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse$outboundSchema:
  z.ZodType<
    DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse$Outbound,
    z.ZodTypeDef,
    DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse
  > = z.instanceof(
    DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse$ {
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse$inboundSchema;
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse$outboundSchema;
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse$Outbound` instead. */
  export type Outbound =
    DeleteApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysKeyIdErrorResponse$Outbound;
}
